import {Component, Input, OnInit, ViewChild} from '@angular/core';
import {AnalysisKey, SearchResult} from '../../../model/analysis-details.model';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort, Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import {MatSortModule} from '@angular/material/sort';
import { I } from '@angular/cdk/keycodes';


@Component({
    selector: 'app-show-table',
    templateUrl: './show-table.component.html',
    styleUrls: ['./show-table.component.scss'],
    standalone: false
})
export class ShowTableComponent implements OnInit {

  @ViewChild('RApaginator', {static: false}) paginator: MatPaginator;
  @ViewChild(MatSort, {static: false}) sort: MatSort;
  dataSource: MatTableDataSource<AnalysisKey>;
  tableColumns: string[] = ['analysisType', 'analysisDate',  'projectNames', 'analyteName', 'assayType', 'studyCode'];

  reportAnalysis: AnalysisKey[] = [];

  @Input() searchResults: AnalysisKey[] = [];
  count: number;

  constructor() {}

  ngOnInit() {
    this.dataSource = new MatTableDataSource(this.searchResults);
    // console.log('this data source', this.dataSource);
    setTimeout(() => this.dataSource.paginator = this.paginator);
    this.dataSource.sortingDataAccessor = (item, property) => {
      switch (property) {
        case 'analysisDate': return new Date(item.analysisDate);
        // case 'analysisDate': return item.analysisDate;
        case 'projectNames': return item.projectNames ;
        case 'analyteNames': return item.analyteNames ;
        default: return item[property];
      }
    }
    setTimeout(() => this.dataSource.sort = this.sort);

    for (const result of this.searchResults) {
      this.reportAnalysis.push(result);
    }
    this.dataSource = new MatTableDataSource(this.reportAnalysis);
    setTimeout(() => this.dataSource.paginator = this.paginator);
    setTimeout(() => {this.dataSource.sort = this.sort});

  }

  getUrl(analysisType: string) {
    return '/default-layout/molecule-analysis';
  }



  applyFilter(filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

}
